// img
import 'lazysizes';
import ready from '../utils/ready';

// bg-images
const lazyBackgroundImageHandler = () => {
  // use same default expand as lazysizes
  const docElem = document.documentElement;
  const defaultExpand = window.lazySizes?._defEx
    ? window.lazySizes._defEx
    : docElem.clientHeight > 500 && docElem.clientWidth > 500
      ? 500
      : 370;

  let lazyloadImages: NodeListOf<HTMLElement>;
  if ('IntersectionObserver' in window) {
    lazyloadImages = document.querySelectorAll('.lazy-background-image');
    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const image = entry.target;
            image.classList.remove('lazy-background-image');
            imageObserver.unobserve(image);
          }
        });
      },
      { rootMargin: `0px 0px ${defaultExpand}px 0px` }
    );

    lazyloadImages.forEach((image) => {
      imageObserver.observe(image);
    });
  } else {
    let lazyloadThrottleTimeout: number;
    lazyloadImages = document.querySelectorAll('.lazy-background-image');

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(() => {
        const scrollTop = window.pageYOffset;
        lazyloadImages.forEach((img) => {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.classList.remove('lazy-background-image');
          }
        });
        if (lazyloadImages.length == 0) {
          document.removeEventListener('scroll', lazyload);
          window.removeEventListener('resize', lazyload);
          window.removeEventListener('orientationChange', lazyload);
        }
      }, 20) as unknown as number;
    }

    document.addEventListener('scroll', lazyload);
    (window as Window).addEventListener('resize', lazyload);
    (window as Window).addEventListener('orientationChange', lazyload);
  }
};

ready(lazyBackgroundImageHandler);
